import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import AboutHeader from '../components/AboutHeader';
import OurCommitment from '../components/OurCommitment';
import FaqSection from '../components/FaqSection';
import './FullAboutPage.css';
import useSEO from '../hooks/useSEO';

const FullAboutPage = () => {
    useSEO({
        title: "About Prime Rehab Industries | Physiotherapy Equipment Manufacturer, Chennai",
        description: "Learn about Prime Rehab Industries, a Chennai-based manufacturer of physiotherapy, chiropractic and rehabilitation equipment serving clinics and hospitals across Tamil Nadu and India.",
        canonical: "https://www.primerehabindustries.in/about"
    });
    // Scroll to top when the page loads
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="full-about-page">
            <Navbar />

            <main className="about-page-content">
                <AboutHeader />
                <OurCommitment />
                <FaqSection />
            </main>

            <Footer />
        </div>
    );
};

export default FullAboutPage;
